export default __webpack_public_path__ + "navigation-examples-custom-server-v1-960-2e7d770b2d3c629ebefe71757bc7aaa7.png";